var _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHousingAuthority({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28.272,
    height: 24.031,
    viewBox: "0 0 28.272 24.031",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #8f003c;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "roofing_FILL0_wght400_GRAD0_opsz48",
    className: "cls-1",
    d: "M4,18.723,18.136,6,25.2,12.361V8.12h2.827v6.785l4.241,3.817H29.127L18.136,8.863,7.145,18.723ZM14.249,30.031V22.257h7.775v7.775Zm2.12-2.12H19.9V24.377H16.369Z",
    transform: "translate(-4 -6)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHousingAuthority);
export default __webpack_public_path__ + "static/media/housing-authority.c49e5c1e05cb225d8225a23f941d05b7.svg";
export { ForwardRef as ReactComponent };